import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Button, Text, Quote } from "@radix-ui/themes";
import { FcGoogle } from "react-icons/fc";
import { FaGithub, FaFacebook } from "react-icons/fa";

const LoginPage = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BE_URL;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleLogin = (serviceName) => {
    // Redirect to the backend for Google authentication
    window.location.href = `${baseUrl}/auth/${serviceName}`;
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const quotes = [
    "All evils are caused by insufficient knowledge.",
    "All fiction that does not violate the laws of physics is fact.",
    "An optimistic civilization is open and not afraid to innovate, and is based on traditions of criticism.",
    "Problems are inevitable. But problems are also soluble.",
  ];
  const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div>
        <Flex gap="4" align="center" direction="column">
          <Text
            style={{
              fontFamily: "'Bungee Hairline', sans-serif",
              fontWeight: 600,
              fontSize: windowWidth <= 600 ? "50px" : "120px",
              height: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            className="responsive-text"
          >
            TELLOS AI
          </Text>

          <Text style={{ fontSize: windowWidth <= 600 ? "12px" : "22px" }}>
            <Text>
              <Quote>{randomQuote}</Quote> — David Deutsch
            </Text>
          </Text>
          <Button
            size="3"
            variant="soft"
            style={{ minWidth: "100px", width: "250px", cursor: "pointer" }}
            onClick={() => handleLogin("google")}
          >
            <FcGoogle size={25} />
            <Text>Sign in with Google</Text>
          </Button>
          {/* <Button
            size="3"
            variant="soft"
            style={{ minWidth: "100px", width: "250px", cursor: "pointer" }}
            onClick={() => handleLogin("facebook")}
          >
            <FaFacebook size={25} />
            <Text>Sign in with Facebook</Text>
          </Button> */}
          {/* <Button
            size="3"
            variant="soft"
            style={{ minWidth: "100px", width: "250px", cursor: "pointer" }}
            onClick={() => handleLogin("outlook")}
          >
            <PiMicrosoftOutlookLogoFill size={25} />
            <Text>Sign in with Outlook</Text>
          </Button> */}
          <Button
            size="3"
            variant="soft"
            style={{ minWidth: "100px", width: "250px", cursor: "pointer" }}
            onClick={() => handleLogin("github")}
          >
            <FaGithub size={25} />
            <Text>Sign in with GitHub</Text>
          </Button>
        </Flex>
      </div>
    </div>
  );
};

export default LoginPage;
